import { createParameterMenu } from "./components/menu/createParameterMenu";
import { setupIcons } from "./utils/setupIcons";
import { createViewport } from "./viewport";
import { createSession } from "./session";

(async () => {
  const viewport = await createViewport();
  const session = await createSession();
  const canvas = document.getElementById("canvas-container");
  if (!canvas || !session) return;

  createParameterMenu(session, viewport);

  const spinner = document.getElementById("spinner") as HTMLDivElement;
  spinner.style.display = "none";

  setupIcons(canvas, viewport);
})();
